export default __webpack_public_path__ + "static/star_b.1d92452bff98c4fea3f23397f67fd134.png";